import templateUrl from "emun.order/backorders/backorders-list-grid.htm";

export default () => ({ templateUrl });